<template>
  <div id="page-forms">
    <div class="sub-titulo">
      <v-subheader class="sub-titu">
        - Proveedor: {{ nombreProveedor }}, Contrato: {{ codContrato }},
        Período: {{ perContrato }}</v-subheader
      >
    </div>
    <grupo-procesos
      :idContrato="contratoId"
      :proceso="proceso"
    ></grupo-procesos>
    <v-layout align-center justify-center>
      <v-flex lg12>
        <template>
          <v-tabs v-model="active_tab">
            <v-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="selected(tab)"
              >{{ tab }}</v-tab
            >
            <v-tabs-items>
              <!-- TAB DE PROVEEDOR -->
              <v-card flat v-if="tabSelected == 'Proveedor'">
                <proveedor-tab
                  :show="true"
                  :tipeView="'consulta'"
                  :contratoId="contratoId"
                ></proveedor-tab>
              </v-card>
              <!-- TAB DE PROCESO -->
              <v-card flat v-if="tabSelected == 'Proceso'">
                <proceso-tab-aplicacion
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></proceso-tab-aplicacion>
              </v-card>
              <!-- TAB PANEL DE CONTROL -->
              <v-card flat v-if="tabSelected == 'Panel de control'">
                <panel-control-tab
                  show="true"
                  :idContrato="contratoId"
                ></panel-control-tab>
              </v-card>
            </v-tabs-items>
          </v-tabs>
        </template>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import ProveedorTab from "@/modules/configuration/commonsviews/ProveedorTab.vue";
import ProcesoTabAplicacion from "@/modules/aplicacion/views/proceso/ProcesoTabAplicacion.vue";
import PanelControlTab from "@/modules/configuration/contrato/PanelControlTab.vue";
import GrupoProcesos from "@/components/GrupoProcesos.vue";

export default {
  name: "proceso-aplicacion",

  components: {
    ProveedorTab,
    GrupoProcesos,
    ProcesoTabAplicacion,
    PanelControlTab,
  },
  props: {},

  data: () => ({
    tabs: ["Proveedor", "Proceso"],
    contratoId: 0,
    proceso: "",
    tabSelected: "",
    index: "",
    active_tab: "",
    nombreProveedor: "",
    codContrato: "",
    perContrato: "",
  }),
  mounted() {},
  created() {
    this.contratoId = Number(this.$route.params.contratoId);
    this.proceso = this.$store.getters.proSelectedStored;
    this.nombreProveedor = this.$store.getters.nombreProveedorStored;
    this.codContrato = this.$store.getters.contratoCodStored;
    this.perContrato = this.$store.getters.contratoPerStored;
    this.loadSelected();

    if (this.$store.getters.userLogged.tipo == "ADMINISTRADOR") {
      this.tabs.push("Panel de control");
    }
    this.active_tab = this.tabs.indexOf(this.$store.getters.tabSelectedStored);
  },
  methods: {
    loadSelected() {
      this.tabSelected = this.$store.getters.tabSelectedStored;
    },
    selected(tab) {
      this.tabSelected = tab;
      this.$store.commit("sub_pro_tab_state", "");
      this.$store.commit("sub_tab_state", "");
    },
  },
};
</script>
